export default __webpack_public_path__ + "static/media/pause_icon.de9d3053.svg";